import { useEffect, useState } from "react";
import { fetchSettings, updateSettings } from "../../services/settingsApi";

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    minimumiosSupported: "",
    minimumAndroidSupported: "",
    storeIosAppLink: "",
    storeAndroidAppLink: "",
    appSwitchStatus: "0",
    appSwitchMessage: "",
    maintenanceStatus: "0",
    maintenanceMessage: "",
    updateAppMessage: "",
    favMsg: "",
    deleteAccount: "0",
  });

  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const res = await fetchSettings();
      if (res.success && res.data?.config) {
        setSettings(res.data.config);
      }
    } catch (err) {
      console.error("Failed to load settings", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings({ ...settings, [name]: value });
  };

  const handleSave = async () => {
    try {
      const res = await updateSettings(settings);
      if (res.success) {
        alert("✅ Settings updated successfully");
        setEditMode(false);
      }
    } catch {
      alert("❌ Update failed");
    }
  };

  if (loading) return <p>Loading settings...</p>;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <h3>⚙ App Configuration</h3>

          {!editMode ? (
            <button style={styles.editBtn} onClick={() => setEditMode(true)}>
              Edit
            </button>
          ) : (
            <div style={{ display: "flex", gap: 10 }}>
              <button style={styles.saveBtn} onClick={handleSave}>
                Save
              </button>
              <button
                style={styles.cancelBtn}
                onClick={() => {
                  setEditMode(false);
                  loadSettings();
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>

        <SettingField label="Android Min Version" name="minimumAndroidSupported" {...props()} />
        <SettingField label="iOS Min Version" name="minimumiosSupported" {...props()} />

        <SettingField label="Android App Link" name="storeAndroidAppLink" {...props()} />
        <SettingField label="iOS App Link" name="storeIosAppLink" {...props()} />

        <SettingField label="App Switch Status (0/1)" name="appSwitchStatus" {...props()} />
        <SettingField label="App Switch Message" name="appSwitchMessage" {...props()} textarea />

        <SettingField label="Maintenance Status (0/1)" name="maintenanceStatus" {...props()} />
        <SettingField label="Maintenance Message" name="maintenanceMessage" {...props()} textarea />

        <SettingField label="Update App Message" name="updateAppMessage" {...props()} textarea />
        <SettingField label="Festival Message" name="favMsg" {...props()} textarea />

        {/* <SettingField label="Delete Account (0/1)" name="deleteAccount" {...props()} /> */}
      </div>
    </div>
  );

  function props() {
    return {
      value: settings,
      editMode,
      onChange: handleChange,
    };
  }
}

/* ===== Reusable Field ===== */
function SettingField({ label, name, value, editMode, onChange, textarea }) {
  return (
    <div style={styles.row}>
      <label style={styles.label}>{label}</label>

      {editMode ? (
        textarea ? (
          <textarea
            name={name}
            value={value[name] || ""}
            onChange={onChange}
            style={{ ...styles.input, height: 80 }}
          />
        ) : (
          <input
            name={name}
            value={value[name] || ""}
            onChange={onChange}
            style={styles.input}
          />
        )
      ) : (
        <div style={styles.value}>{value[name] || "-"}</div>
      )}
    </div>
  );
}

/* ===== Styles ===== */
const styles = {
  container: { maxWidth: 900, margin: "0 auto" },
  card: {
    background: "#fff",
    borderRadius: 14,
    padding: 24,
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    borderBottom: "1px solid #eee",
    paddingBottom: 12,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "260px 1fr",
    marginBottom: 16,
    alignItems: "center",
  },
  label: { color: "#6b7280", fontSize: 14 },
  value: { fontWeight: 600 },
  input: {
    padding: 10,
    borderRadius: 8,
    border: "1px solid #d1d5db",
    fontSize: 14,
  },
  editBtn: { background: "#2563eb", color: "#fff", padding: 8, border: "none" },
  saveBtn: { background: "#16a34a", color: "#fff", padding: 8, border: "none" },
  cancelBtn: { background: "#e5e7eb", padding: 8, border: "none" },
};
